import { render } from "./PopperWrapperGreen.vue?vue&type=template&id=37b09007&scoped=true"
import script from "./PopperWrapperGreen.vue?vue&type=script&lang=js"
export * from "./PopperWrapperGreen.vue?vue&type=script&lang=js"

import "./PopperWrapperGreen.vue?vue&type=style&index=0&id=37b09007&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b09007"]])

export default __exports__